<app-page-header [header]="pageTitle" backgroundPath="assets/images/lead/lead-news.jpg"></app-page-header>

<div class="container" style="padding-top: 30px;">
    <section class="section-select -menu visible-sm visible-xs show-on-min">
        <app-dropdown [title]="pageTitle" [valueDropdown]="valueDropdown" (selected)="selectValue($event)">
        </app-dropdown>
    </section>
    <ul class="nav nav-tabs tab-four show-on-max" id="myTab" role="tablist">
        <li class="nav-item">
            <a class="nav-link {{choiceFromSelect==='News'? 'active': ''}}" id="one-tab" data-toggle="tab"
                [routerLink]="['/th', 'News']" role="tab" aria-controls="one" aria-selected="true" href="#one"
                (click)="selectValue(1)">
                {{language.newsmenutab1}}
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link {{choiceFromSelect==='Announcement'? 'active': ''}}" id="two-tab" data-toggle="tab"
                [routerLink]="['/th', 'Announcement']" role="tab" aria-controls="two" aria-selected="false" href="#two"
                (click)="selectValue(2)">
                {{language.newsmenutab2}}
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link {{choiceFromSelect==='EarthUpdate'? 'active': ''}}" id="three-tab" data-toggle="tab"
                [routerLink]="['/th', 'EarthUpdate']" role="tab" aria-controls="three" aria-selected="false"
                href="#three" (click)="selectValue(3)">
                {{language.newsmenutab3}}
            </a>
        </li>
    </ul>

    <div class="tab-content" id="myTabContent">
        <div [ngSwitch]="choiceFromSelect">
            <div *ngSwitchCase="'News'" class="tab-pane fade show active" id="one" role="tabpanel"
                aria-labelledby="one-tab" style="padding-top: 30px">
                <div class="period-header-wrapper">
                    <span class="period-header">{{language.newstime}}</span>
                    <div class="btn-group select-news-period">
                        <button type="button" class="btn btn-secondary detail-dropdown">{{selectNewsPeriod}}</button>
                        <button type="button" class="btn btn-secondary dropdown-toggle-split" style="border-radius: 100px;
                            width: 48px; height: 48px; border: 1px solid orange; background-color: white"
                            id="dropdownMenuReference" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            data-reference="parent">
                            <i class="icon caret" style="color: orange"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuReference" style="width: 100%;">
                            <a class="dropdown-item"
                                (click)="setNewsPeriod($event.target.text)">{{language.newstime1m}}</a>
                            <a class="dropdown-item"
                                (click)="setNewsPeriod($event.target.text)">{{language.newstime3m}}</a>
                            <a class="dropdown-item"
                                (click)="setNewsPeriod($event.target.text)">{{language.newstime6m}}</a>
                            <a class="dropdown-item"
                                (click)="setNewsPeriod($event.target.text)">{{language.newstime9m}}</a>
                            <a class="dropdown-item"
                                (click)="setNewsPeriod($event.target.text)">{{language.newstime12m}}</a>
                        </div>
                    </div>
                </div>
                <section class="show-listing -highlight">
                    <div *ngIf="flag == 'th'; else elsehighlightNews">
                        <div class="row">
                            <div *ngFor="let item of highlightNews" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new " *ngIf="item.news_img_Thum != '' ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/News/detail',item.newsid]" class="parent">
                                            <span *ngIf="item.news_img_Thum == ''" class="img-photo img-fluid"
                                                style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                            <span *ngIf="item.news_img_Thum != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.news_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a [routerLink]="['/th/News/detail',item.newsid]">{{item.tItle}}</a>
                                        </h3>
                                        <time>{{date_thai(item.publicDate)}} </time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elsehighlightNews>
                        <div class="row">
                            <div *ngFor="let item of highlightNews" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new " *ngIf="item.news_img_Thum_en != '' ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/News/detail',item.newsid]" class="parent">
                                            <span *ngIf="item.news_img_Thum_en == ''" class="img-photo img-fluid"
                                                style="background-image: url('../../../assets/images/thumb/photo-1.png')"></span>
                                            <span *ngIf="item.news_img_Thum_en != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.news_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a [routerLink]="['/th/News/detail',item.newsid]">{{item.tItle_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}} </time>
                                    </div>
                                </section>
                            </div>
                        </div>

                    </ng-template>
                </section>
                <section class="show-listing">
                    <div *ngIf="flag == 'th'; else elserenderNews">
                        <div class="row">
                            <div *ngFor="let item of renderNews" class="col-ss-12 col-xs-6 col-md-6 col-lg-4">
                                <section id="newsList-2" class="card -new">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/News/detail',item.newsid]" class="parent">
                                            <span *ngIf="item.news_img_Thum != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.news_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a [routerLink]="['/th/News/detail',item.newsid]">{{item.tItle}}</a>
                                        </h3>
                                        <time>{{date_thai(item.publicDate)}} </time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elserenderNews>
                        <div class="row">
                            <div *ngFor="let item of renderNews" class="col-ss-12 col-xs-6 col-md-6 col-lg-4">
                                <section id="newsList-2" class="card -new">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/News/detail',item.newsid]" class="parent">
                                            <span *ngIf="item.news_img_Thum_en != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.news_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a [routerLink]="['/th/News/detail',item.newsid]">{{item.tItle_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}} </time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </ng-template>
                </section>
                <footer class="text-center" style="padding-top: 40px">
                    <app-paginator [currentPage]="newsCurrentPage" [totalPage]="totalNewsPage"
                        (currentPageNumber)="setCurrentNewsPage($event)"></app-paginator>
                </footer>
            </div>

            <div *ngSwitchCase="'Announcement'" class="tab-pane fade show active" id="two" role="tabpanel"
                aria-labelledby="two-tab">
                <section class="announce-detail" style="padding-top: 30px;">
                    <ul class="list-announce row">
                        <li data-mh="desc-announce" *ngFor="let item of renderAnnounce"
                            class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6">
                            <div *ngIf="flag == 'th'; else elseAnnouncement">
                                <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                                <span
                                    class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                                <a *ngIf="item.title !=' '" [routerLink]="['/th/Announce/detail',item.announceid]"
                                    class="visible-touch">
                                    <p>{{item.title}} </p>
                                </a>
                            </div>
                            <ng-template #elseAnnouncement>
                                <span class="date">{{item.publicDate | date:'dd'}}</span>
                                <span
                                    class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                                <a *ngIf="item.title_en !=' '" [routerLink]="['/th/Announce/detail',item.announceid]"
                                    class="visible-touch">
                                    <p>{{item.title_en}} </p>
                                </a>
                            </ng-template>
                        </li>
                    </ul>
                </section>
                <footer class="text-center" style="padding-top: 40px">
                    <app-paginator [currentPage]="newsCurrentPage_announce" [totalPage]="totalNewsPage_announce"
                        (currentPageNumber)="setCurrentNewsPage_announce($event)"></app-paginator>
                </footer>
            </div>

            <div *ngSwitchCase="'EarthUpdate'" class="tab-pane fade show active" id="three" role="tabpanel"
                aria-labelledby="three-tab">
                <section class="announce-detail" style="padding-top: 30px;">
                    <ul class="list-announce row">
                        <li data-mh="desc-announce" *ngFor="let item of renderEartUpdate"
                            class="col-12 offset-0 offset-sm-3 offset-lg-0 col-lg-6">
                            <div *ngIf="flag == 'th'; else elseEarthUpdate">
                                <span class="date">{{date_thai_dd(item.publicDate)}}</span>
                                <span
                                    class="month-year">{{date_thai_mm(item.publicDate)}}<br>{{date_thai_yy(item.publicDate)}}</span>
                                <a [routerLink]="['/th/EartUpdate/detail',item.earthupdateid]" class="visible-touch">
                                    <p>{{item.title}} </p>
                                </a>
                            </div>
                            <ng-template #elseEarthUpdate>
                                <span class="date">{{item.publicDate | date:'dd'}}</span>
                                <span
                                    class="month-year">{{item.publicDate | date:'MMMM'}}<br>{{item.publicDate | date:'yyyy'}}</span>
                                <a [routerLink]="['/th/EartUpdate/detail',item.earthupdateid]" class="visible-touch">
                                    <p>{{item.title_en}} </p>
                                </a>
                            </ng-template>
                        </li>
                    </ul>
                </section>
                <footer class="text-center" style="padding-top: 40px">
                    <app-paginator [currentPage]="newsCurrentPage_eartupdate" [totalPage]="totalNewsPage_eartupdate"
                        (currentPageNumber)="setCurrentNewsPage_eartupdate($event)"></app-paginator>
                </footer>
            </div>
        </div>
    </div>
</div>